import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataCoreService, DlistDto, GetDlist_Request, GetDlist_Response} from '@dabnet-kamu/libs/ui';
import { BehaviorSubject, catchError, finalize, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@dabnet-kamu/libs/ui';
import { ControlConditionModel } from '../../../models/gen-control.model';

@Injectable()
export class GenDropBoxKontrolService {
  public period : number;
  public conditionColName: any;
  public conditionColText: any;
  public controlCondition: ControlConditionModel[];
  public customQuery = "";
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsList$ = this._gridControlsList.asObservable();
  constructor(private dataCoreService: DataCoreService,private _httpClient:HttpClient) {}

  getData(filterColumn:string,code: any, control: any, type:string,codeField?:string, key?:string) {
    const columnArray: string[] = control.searchColumns?.split(',');
    const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity + this.customQuery, null, null, key);
    dataSource.select(columnArray);
    const filterArr = [];
    if(code){
      if(type === "number") filterArr.push([control.kodField, '=', Number(code)]);
      else if (type === "string"){
        if(filterColumn.length > 0)filterArr.push([control.kodField, 'startswith', code]);
        else {
          if(codeField){
            filterArr.push([codeField, '=', code]);
          } else {
            filterArr.push([control.kodField, '=', code]);
          }
        }
      }
    }
    if(this.period) filterArr.push(['Donem', '=', this.period]);
    if(this.conditionColName && this.conditionColText) filterArr.push([this.conditionColName, '=', this.conditionColText]);
    if(this.controlCondition){
        this.controlCondition.forEach((item:any) => {
          filterArr.push([item.conditionColName, item.conditionColSymbol, item.conditionColText]);
        });
    }
    if (filterArr.length > 0) dataSource.filter(filterArr);
    return dataSource;
  }

  getDlist(formName:string):any {
    const request=new GetDlist_Request({
      dListCode:formName
    })
     this._httpClient.post<GetDlist_Response>(`${env.lookupService}/System/GetDList`, request).pipe(
      tap(response => {
        this._gridControlsList.next(response.dListMetadata)
      }),
      catchError(err => throwError(err)),
      finalize(() => {})
    ).subscribe();
  }

}
